import { render, staticRenderFns } from "./NewTabCategoryCourier.vue?vue&type=template&id=07a4a152&"
import script from "./NewTabCategoryCourier.vue?vue&type=script&lang=js&"
export * from "./NewTabCategoryCourier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports